import { useLang } from "../../context/LangContext";
import { PARTNERS } from "../../lib/i18n";
import { LogoMark } from "./Logo";

export const Partners = () => {
  const { t } = useLang();
  const row = [...PARTNERS, ...PARTNERS];
  return (
    <section id="partner" data-testid="partners-section" className="relative overflow-hidden border-y border-white/10 bg-[#0a0a0b] py-20 text-[#fafaf7] md:py-28">
      <div className="wrap mb-12 flex items-center justify-between">
        <p className="eyebrow">{t.partners.eyebrow}</p>
        <p className="font-mono text-[11px] tracking-[0.3em] text-white/30">{PARTNERS.join(" · ")}</p>
      </div>
      <div className="relative [mask-image:linear-gradient(90deg,transparent,black_12%,black_88%,transparent)]">
        <div className="animate-marquee flex w-max items-center" data-testid="partners-marquee">
          {[...row, ...row].map((p, i) => (
            <span key={i} className="flex items-center">
              <span className={`px-10 text-6xl leading-none tracking-tight md:px-16 md:text-8xl ${i % 2 ? "font-serif-i gold-text" : "font-display font-bold"}`}>{p}</span>
              <LogoMark className="h-8 w-8 text-white/30" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
